// Leads with a bolded summary per the Figma toast, which a plain string can't express — sonner
// takes a ReactNode, so the copy lives here as markup.
export function EmailVerificationLinkSentToast() {
    return (
        <span>
            <span className="font-semibold">Link sent.</span> Check your inbox to verify your email.
        </span>
    );
}
